import { Component, OnInit } from '@angular/core';
import { ModalConfig, ModalService } from '@freelancer/ui';
import { PaymentsModalComponent } from 'app/financial-operations/payments-deposit/payments-modal/payments-modal.component';
import { AwardModalComponent } from 'app/projects/award-modal/award-modal.component';
import { ProjectViewOverlayModalComponent } from 'app/projects/project-view/project-view-overlay-modal/project-view-overlay-modal.component';
import { TaskWelcomeModalComponent } from 'app/tasks/task-welcome-modal/task-welcome-modal.component';

export const MODALS_MAP = {
  AwardModalComponent,
  PaymentsModalComponent,
  ProjectViewOverlayModalComponent,
  TaskWelcomeModalComponent,
};

@Component({
  selector: 'webapp-compat-modals',
  template: `
    <fl-modal></fl-modal>
  `,
})
export class CompatModalsComponent implements OnInit {
  constructor(private modalService: ModalService) {}

  ngOnInit() {
    const w = <any>window;
    w.webappCompatModals = {
      open: (componentName: keyof typeof MODALS_MAP, config: ModalConfig) =>
        this.modalService
          .open(MODALS_MAP[componentName] as any, config)
          .afterClosed()
          .toPromise(),
    };
    if (w.webappCompatModalsReadyCallback) {
      w.webappCompatModalsReadyCallback();
    }
  }
}
